import type { ReactNode } from 'react'
import { StyledHelp, StyledHelpBody, StyledHelpSummary } from '../styled-components'

interface HelpPanelProps {
  hidden?: boolean
  title: string
  children: ReactNode
}

const HelpPanel = ({ hidden = false, title, children }: HelpPanelProps) => {
  if (hidden) {
    return null
  }

  return (
    <StyledHelp>
      <StyledHelpSummary>{title}</StyledHelpSummary>
      <StyledHelpBody>{children}</StyledHelpBody>
    </StyledHelp>
  )
}

export default HelpPanel
